import { BRAND } from '@config';
import { brandList } from './../../../../app.values';
import { chLoadingParams } from './ch-loading.class';

export class LoadFactors {

  constructor(
    deadLoad = BRAND === brandList.Sea ? 2 : 1.35,
    liveLoad = 1.5,
    tempLoad = 1.75,
  ) {
    this[chLoadingParams.DEAD_LOAD] = deadLoad;
    this[chLoadingParams.LIVE_LOAD] = liveLoad;
    this[chLoadingParams.TEMPORARY_LOAD] = tempLoad;
  }

}



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/CharacteristicsLoading/load-coefficients.class.js